module.exports = __webpack_public_path__ + "img/icon.b325ff31.png";